import categoriesForIntakeJSON from "../../data/_categoriesForIntake.json";
import FormApi from "../../services/api/formApi.js";

const FormApiService = new FormApi();

export default {
  data() {
    return {
      categories: [],
      model: {
        brandName: "",
        brandWebsite: "",
        brandInstagram: "",
        city: "",
        contactName: "",
        email: "",
        shippingFrom: "",
        leadTime: "",
        productCategory: "",
        quantityMinimums: "",
        productCustomization: "Yes",
        notes: "",
        bestSeller1: "",
        bestSeller2: "",
        bestSeller3: "",
        bestSeller4: "",
        bestSeller5: "",
      },
      productCategoryNotValid: false,
    };
  },

  methods: {
    submit: submit,
    resetModel: resetModel,
    onSelectCategory: onSelectCategory,
  },

  beforeMount() {
    this.categories = this.$utils.deepClone(categoriesForIntakeJSON);
  },
};

function submit() {
  let _self = this;
  _self.productCategoryNotValid = false;

  _self.$validator.validate().then((valid) => {
    if (!_self.model.productCategory.length) {
      _self.productCategoryNotValid = true;
      return false;
    }
    if (!valid) {
      return false;
    } else {
      FormApiService.applyAsBrand(_self.model)
        .then(() => {
          _self.$swal("Success", "Application submited successfully");
          this.$nextTick(() => this.$validator.reset());
          _self.resetModel();
        })
        .catch(() => {
          _self.$swal("Alert", "Something went wrong. Please try again later");
        });
    }
  });
}

function onSelectCategory(object) {
  this.model.productCategory = object.name;
}

function resetModel() {
  this.model = {
    brandName: "",
    brandWebsite: "",
    brandInstagram: "",
    city: "",
    contactName: "",
    email: "",
    shippingFrom: "",
    leadTime: "",
    productCategory: "",
    quantityMinimums: "",
    productCustomization: "Yes",
    notes: "",
  };
}
